import React from 'react'
import { Box, SxProps, Theme } from '@mui/material'
import { INTERAX_COLORS } from '../constants/colors'

export interface BackgroundBoxHeritageContainerProps {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  sx?: SxProps<Theme>
}

/**
 * BackgroundBoxHeritageContainer Component
 *
 * A styled container specifically designed for recommendations sections
 * Features heritage blue background with shadow and proper spacing
 *
 * @param children - Content to be rendered inside the container
 * @param className - Additional CSS classes
 * @param style - Custom inline styles
 */
export const BackgroundBoxHeritageContainer: React.FC<BackgroundBoxHeritageContainerProps> = ({
  children,
  className = '',
  style = {},
  sx = {}
}) => {
  const containerStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: '24px',
    gap: '24px',
    width: '100%',
    background: INTERAX_COLORS.heritageBlue40,
    boxShadow: '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1)',
    borderRadius: '16px',
    flex: 'none',
    ...style
  }

  return (
    <Box sx={{ ...containerStyles, ...sx }} className={className}>
      {children}
    </Box>
  )
}

export default BackgroundBoxHeritageContainer
